export const Logo = ({ className = "h-16" }) => (
  <img
    src="/logo-full.png"
    alt="TecnoEdil.EA S.R.L.S — Costruzioni & Restauri"
    className={`w-auto ${className}`}
    data-testid="brand-logo"
  />
);
